import { createContext, useContext } from 'react';

export type GnRole = 'tutor' | 'student';

/**
 * Ambient context for GN block node-views (spec 046). TipTap node views can't receive
 * props from the host page, so the notebook host (GnNotebook) provides role + scope here —
 * e.g. MediaClipNode needs the role to pick the right playback-URL endpoint, and
 * TutorPublishedRegionNode needs course/node scope plus the seen-published callback.
 */
export interface GnContextValue {
  role: GnRole;
  courseId: number;
  nodeId: number | null;
  /** Student topic GNs only: last publishedAt the student has acknowledged (FR-039). */
  lastSeenPublishedAt: string | null;
  /** Student topic GNs only: mark the current published version as seen. */
  markPublishedSeen: (publishedAt: string) => void;
  /** Bumped when a new publish may exist (live-session seq change) — the tutor region refetches. */
  publishRefreshKey: number;
  /** Canvas vs pages (spec 046 US3, FR-028) — pageBreak nodes render as dividers only in CANVAS. */
  viewPref: 'CANVAS' | 'PAGES';
}

export const GnContext = createContext<GnContextValue>({
  role: 'student',
  courseId: 0,
  nodeId: null,
  lastSeenPublishedAt: null,
  markPublishedSeen: () => {},
  publishRefreshKey: 0,
  viewPref: 'CANVAS',
});

export const useGnContext = () => useContext(GnContext);
